import React, { useEffect, useCallback, useState} from 'react';
import SourceResults from './SourceResults.js';
import UnsourcedFlow from "components/installation/UnsourcedFlow.js";
import {connect} from 'react-redux';

const SourceEditor = ({source, sequencerEngine}) => { 
    console.log('un sourced flow');
    return (
        <div>
          <div className="unsourced-header">
            Edit Source Information
          </div>
          <UnsourcedFlow show={true} samples={source.results}/>
          <SourceResults alone={true} sequencerEngine={sequencerEngine} source={source}/> 
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SourceEditor);
